import {Title} from '../text'
import {useLegacyModalContext} from './modal_context'
import './styles/header.less'
import {Icon} from '../icon'

export const ModalHeader = props => {
	const {RightHeader = Cross} = props
	return (
		<div className="eitje-modal-2-header">
			<div className="eitje-modal-2-header-left">
				<ModalLeftHeader {...props} />
			</div>
			<div className="eitje-modal-2-header-right">{RightHeader && <RightHeader {...props} children={null} />}</div>
		</div>
	)
}

const Cross = () => {
	const {onCancel} = useLegacyModalContext()
	return <Icon name="cross" onClick={onCancel} />
}

const ModalLeftHeader = props => {
	const {title, LeftHeader, subtitle} = props
	const {t} = useLegacyModalContext()
	const subText = subtitle == true ? t('subtitle') : subtitle

	const _title = title || t('title')

	return (
		<div className="eitje-modal-2-left-header-titles">
			<Title truncate>{_title}</Title>
			{LeftHeader && <LeftHeader />}
			{!!subtitle && (
				<h5 className="eitje-modal-2-subtitle" style={{flexShrink: 0, marginRight: '12px'}}>
					{subText}
				</h5>
			)}
		</div>
	)
}
